module.exports = __webpack_public_path__ + "img/tema-1-7.5ac4064e.svg";